import { EMPTY, of } from 'rxjs';

import { app } from '../../app';

const PLAYER_FINANCIAL_HISTORY = 'PlayerFinancialHistory';
const NEED_RELOGIN = 'needRelogin';

export default function handleErrors(socketMessage) {
  const { MessageType, errorDescription } = socketMessage;

  if (MessageType === PLAYER_FINANCIAL_HISTORY) {
    return errorDescription === NEED_RELOGIN
      ? of(
        app.update({
          error: {
            code: 105, // Show authentication error
          },
        })
      )
      : EMPTY;
  }
}
